//JS for tech library and location list templates.
import {techStarter, techFilterSwitch} from './tech-location-list.js';
import {scsSliders} from './slider.js';
import {primaryNav} from './primary-nav.js';
import {mobileNav} from './mobile-nav.js';
import {tabbedContent} from './tabs.js';
import {cookie} from './cookie.js';
import {scsForms} from './forms.js';
import {scsNews} from './news.js';


// Custom Scripts
(function($) {
    //console.log('Scripts succesfully loaded!');

    cookie();
    scsForms();
    scsNews.postToggle();
    
    const mobile = window.matchMedia('(max-width:991px)');
    mobile.addListener(windowResize);
    windowResize(mobile);
    
    scsSliders();

    const productTabs = document.querySelector('.product-tabs');
    tabbedContent(productTabs);


    //Adds a on click listner to toggle the tech lib filter
    const techFilterSelector = document.querySelectorAll('.tech-filter-selector');
    for(let i = 0; i < techFilterSelector.length; i++){
      techFilterSelector[i].addEventListener('click', event => {
        //handle click
        let filter = techFilterSelector[i].getAttribute("value");
        techFilterSwitch(filter);
      })
    }

    if(document.getElementsByClassName('tech-cat-filter').length > 0) {
      techStarter();
    }

    //Adds a on click listner to toggle the tech lib filter
    const locationFilterSelector = document.querySelectorAll('.location-filter-selector');
    
    for(let i = 0; i < locationFilterSelector.length; i++){
      locationFilterSelector[i].addEventListener('click', event => {
        //handle click
        let filter = locationFilterSelector[i].getAttribute("value");
        techFilterSwitch(filter);
      })
    }

  if(document.getElementsByClassName('location-cat-filter').length > 0) {
    techStarter();
  }





})(jQuery);

function windowResize(mobile){
    if(mobile.matches){
        mobileNav.toggle();
        mobileNav.collapse();
        mobileNav.initialize();
    }else{
        primaryNav.toggle();
        primaryNav.search(); 
    }
}
